import React, { useEffect, useState, createContext, useContext } from 'react';
import { useUserContext } from '../user_context/UserContext';
import { organizationInventorySnapshotListener } from '../../repository/InventoryDAO';
import { UOMsSnapshotListener } from '../../repository/UOMDAO';
import { organizationInventoryLocationListener } from '../../repository/LocationsDAO';
import { organizationSupplierSnapshotListener } from '../../repository/SupplierDAO';

export const InventoryContext = createContext();

export const InventoryProvider = ({ children }) => {
    const { firebaseUser } = useUserContext();
    
    const [inventoryItems, setInventoryItems] = useState([]);
    const [UOMs, setUOMs] = useState([]);
    const [inventoryLocations, setInventoryLocations] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        if (!firebaseUser?.organization) return;

        const unsubscribeInventoryItems = organizationInventorySnapshotListener(
            firebaseUser.organization, 
            setInventoryItems
        );

        const unsubscribeUOMs = UOMsSnapshotListener(
            firebaseUser.organization, 
            setUOMs
        );

        const unsubscribeInventoryLocations = organizationInventoryLocationListener(
            firebaseUser.organization, 
            setInventoryLocations
        );

        const unsubscribeSuppliers = organizationSupplierSnapshotListener(
            firebaseUser.organization, 
            setSuppliers
        );

        return () => {
            unsubscribeInventoryItems();
            unsubscribeUOMs();
            unsubscribeInventoryLocations();
            unsubscribeSuppliers();
        };
    }, [firebaseUser]);

    const getSupplierByID = (supplierId) => {
        return suppliers.find(supplier => supplier.id === supplierId);
    };

    const getLocationByID = (locationId) => {
        return inventoryLocations.find(location => location.id === locationId);
    };

    const resetInventoryContext = () => {
        setInventoryItems([]);
        setUOMs([]);
        setInventoryLocations([]);
        setSuppliers([]);
    };

    return (
        <InventoryContext.Provider
            value={{
                UOMs,
                inventoryLocations,
                suppliers,
                inventoryItems,
                resetInventoryContext,
                getSupplierByID,
                getLocationByID
            }}
        >
            {children}
        </InventoryContext.Provider>
    );
};

export const useInventoryContext = () => {
    return useContext(InventoryContext);
};
